import React from 'react';
import { observer } from 'mobx-react-lite';
import { WheelArrow } from '../index';
import { CirclesSection } from '../../web';
import { circlesArr } from '../../../enums/circlesArr';
import { TimerWrapper } from '../../../containers/common';
import { colorToOddMapper } from '../../../helpers/colorToOddMapper';
import { gameStore, roundTimeStore, wheelStore } from '../../../store';

export const Wheel = observer(({ innerRef }) => {
  const { wheelRoundResult } = wheelStore;
  const { isRoundFinishedHandled, gameAnimationDuration } = gameStore;
  const { time, passedSeconds } = roundTimeStore;

  return (
    <div className='mob-game-circle-ins'>
      <div className='mob-game-circle-ins-inner'>
        <img
          src='data:image/jpeg;base64,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'
          alt=''
        />
        <div className='img-resp-content'>
          <div
            style={{
              animationDelay: `${passedSeconds ? passedSeconds * 1000 : 0}ms`,
              animationDuration: `${gameAnimationDuration}ms`,
            }}
            className={`mob-g-c-line-in ${time === null && isRoundFinishedHandled ? 'anim' : ''}`}
          >
            <CirclesSection circles={circlesArr} />
          </div>
          <div className='mob-hex-circle-wr'>
            <div className='mob-hex-circle-ins'>
              <WheelArrow />
              {!isRoundFinishedHandled ? <TimerWrapper time={time} /> : <></>}
              <div className='mob-h-circle-in'>
                <p
                  style={
                    innerRef?.current
                      ? { fontSize: `${Math.round((innerRef.current.clientHeight / 10) * 4)}px` }
                      : {}
                  }
                  className={`game-circle-int ${wheelRoundResult ? '' : 'd-none'}`}
                >
                  {`x${colorToOddMapper(wheelRoundResult)}`}
                </p>
                <div
                  style={{
                    animationDelay: `${passedSeconds ? passedSeconds * 1000 : 0}ms`,
                    animationDuration: `${gameAnimationDuration}ms`,
                  }}
                  className={`mob-h-circle-in-sc ${
                    isRoundFinishedHandled && time === null ? '' : 'd-none'
                  } ${time === null && isRoundFinishedHandled ? 'anim' : ''}`}
                >
                  <CirclesSection innerRef={innerRef} inner circles={circlesArr} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
